import { FullScreenLoading } from '@civilgrid/ui/components';
import { bbox as turfBBOX } from '@turf/turf';
import { useSnapshot } from 'valtio';
import { MapComponent } from '~/components2/Map';
import type { InitialViewState } from '~/components2/Map/common';
import ProjectDataLayers from '../../map/ProjectDataLayers';
import store from '../store';
import Surface from '../surfaces/Surface';
import ControlButtons from './ControlButtons';
import PrintViewGuide from './PrintViewGuide';
// print view-specific
import PrintViewLegend from './PrintViewLegend';

export default function PrintViewMap() {
  const { project, currentMap, projectId } = useSnapshot(store) as typeof store;

  if (project.isLoading || currentMap.isLoading) {
    return <FullScreenLoading />;
  }

  const projectBounds = turfBBOX(project.geometry as unknown as GeoJSON.Feature);

  const initialViewState: InitialViewState = {
    bounds: [projectBounds[0], projectBounds[1], projectBounds[2], projectBounds[3]],
    fitBoundsOptions: {
      padding: 100,
    },
  };

  return (
    <div
      id="print-view-map-container"
      className="absolute left-0 top-0 z-[10000] flex h-screen w-screen justify-center bg-white"
    >
      <MapComponent
        initialViewState={initialViewState}
        mapStyle={currentMap.baseMap}
        projectGeometry={project.geometry}
        showScale={true}
        includeDefaultContextMenu={false}
        showLayers={true}
        showLayerPicker={true}
      >
        <Surface interactive={false} />
        <ProjectDataLayers projectId={projectId} interactive={false} />
        <ControlButtons />
        <PrintViewLegend />
        <PrintViewGuide />
      </MapComponent>
    </div>
  );
}
